import { ProductDto, PaymentType } from '@app/types/product.type';

export interface PaymentUrls {
  cardUrl?: string;
  paypalUrl?: string;
  walletsUrl?: string;
}

/**
 * Маппинг payment_provider в URL для виджета
 * - stripe → cardUrl и walletsUrl (одинаковый URL)
 * - paypal → paypalUrl
 */
export function mapPaymentProvidersToUrls(product: ProductDto): PaymentUrls {
  const urls: PaymentUrls = {};

  product.payment_provider.forEach((provider) => {
    if (provider.type === 'stripe') {
      // Для Stripe используем один URL для обеих опций (Card и Wallets)
      urls.cardUrl = provider.url;
      urls.walletsUrl = provider.url;
    } else if (provider.type === 'paypal') {
      urls.paypalUrl = provider.url;
    }
    // Остальные провайдеры пока не поддерживаются виджетом
  });

  return urls;
}

/**
 * Получить PaymentType из methodId виджета
 */
export function getPaymentTypeFromMethodId(methodId: string): PaymentType | null {
  if (methodId === 'card' || methodId === 'wallets') {
    return 'stripe';
  }
  if (methodId === 'paypal') {
    return 'paypal';
  }
  return null;
}
